


















import {Stored} from "vue-stored-prop-decorator";
import {Prop} from "vue-property-decorator";
import {Component} from '@/shared/component';
import {AbstractSearchVue} from '@/components/Abstract/AbstractSearchVue';

import InputSearchEntity from '@/components/Input/SearchEntity.vue';
import CrudClientFilterReduce from '@/components/Crud/Client/FilterReduce.vue';
import CrudClientListForSelect from '@/components/Crud/Client/ListForSelect.vue';
import storeClient, {ClientFilter} from "@/stores/modules/client";

@Component({
	components: {
		CrudClientFilterReduce,
		CrudClientListForSelect,
		InputSearchEntity,
	}
})
export default class CrudClientSearch extends AbstractSearchVue {
	//private type: ClientType = null;

	@Stored(() => storeClient) filters: ClientFilter;

	private filterComponent = CrudClientFilterReduce;
	private listComponent = CrudClientListForSelect;

	private async setFilters(): Promise<void> {
		await this.$nextTick();
	}
}
